module.exports = __webpack_public_path__ + "img/call.1af83744.svg";